import { Button, Paper } from '@material-ui/core';
import React from 'react'
import { useSelector } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Draggable from 'react-draggable';
import Slide from '../carrousel/Slide';
import { ViewPdf } from '../carrousel/ViewPdf';

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}
const CarritoDocumentacion = ({ category }) => {
    const documentacionAfiliado = useSelector((state) => state.documentacionAfiliacion);
    const [open, setOpen] = React.useState(false);
    const [docuSelect, setDocuSelect] = React.useState({});

    const handleClickOpen = (docu) => {
        setOpen(true);
        setDocuSelect(docu)
    };

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <Paper style={{ overflow: "auto", whiteSpace: "nowrap", padding: "1rem" }}>
            {
                // eslint-disable-next-line
                documentacionAfiliado.items.map((docu, index) => {
                    if (docu.tipoDocumentacion.idCategoria === category) {
                        return (
                            <Button key={index} onClick={() => handleClickOpen(docu)} variant="outlined" color="primary" style={{ marginRight: "0.5rem", marginLeft: "0.5rem" }}>{docu.tipoDocumentacion.descripcionDocumentacion}</Button>
                        )
                    }
                })
            }
            <Dialog
                open={open}
                onClose={handleClose}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                BackdropProps={{ style: { backgroundColor: "transparent" } }}
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {docuSelect?.tipoDocumentacion?.descripcionDocumentacion}
                </DialogTitle>
                <DialogContent>
                    <Slide
                        // url={`https://www.ospedyc.org.ar/onexa/webapi/Archivos/221474/637643685525320824.pdf`}
                        url={`${process.env.REACT_APP_URL}/${docuSelect?.urlCarpeta}${docuSelect?.nombreDocumento}`}
                        titulo={""}
                        subtitle={""}
                        media={
                        <ViewPdf url={`${process.env.REACT_APP_URL}/${docuSelect?.urlCarpeta}${docuSelect?.nombreDocumento}`} />
                        // <ViewPdf url={`https://www.ospedyc.org.ar/onexa/webapi/Archivos/221474/637643685525320824.pdf`} />
                        }
                        mediaBackgroundStyle={{ backgroundColor: "#fff" }}
                        style={{ backgroundColor: "#fff" }}
                    />
                </DialogContent> 
                <DialogActions>
                    <Button autoFocus onClick={handleClose} color="primary">
                        CERRAR
                    </Button>
                </DialogActions>
            </Dialog>
        </Paper>
    )
}

export default CarritoDocumentacion
